const Config = {
	API_URL: process.env.REACT_APP_API_URL,
	IMAGE_BUCKET_URL: process.env.REACT_APP_IMAGE_BUCKET_URL,
	VERSION: process.env.REACT_APP_VERSION,
	ENV: process.env.REACT_APP_ENV,
};

export default Config;
